import { getLocale } from "../runtime";

const da_handoverparcel = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Når din pakke afsendes, modtager du en e-mail med et sporingslink og mere information.`
};

const en_handoverparcel = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `When your package is shipped, you will receive an email with a tracking link and more information.`
};

const es_handoverparcel = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Cuando tu paquete sea enviado, recibirás un correo electrónico con un enlace de seguimiento y más información.`
};

const fi_handoverparcel = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Kun pakettisi lähetetään, saat sähköpostin, joka sisältää seurantalinkin ja lisätietoja.`
};

const nb_handoverparcel = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Når pakken din sendes, vil du motta en e-post med en sporingskode og mer informasjon.`
};

const sv_handoverparcel = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `När ditt paket skickas får du ett mejl med en spårningslänk och mer information.`
};

const handoverparcel = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "da") return da_handoverparcel(inputs)
	if (locale === "en") return en_handoverparcel(inputs)
	if (locale === "es") return es_handoverparcel(inputs)
	if (locale === "fi") return fi_handoverparcel(inputs)
	if (locale === "nb") return nb_handoverparcel(inputs)
	if (locale === "sv") return sv_handoverparcel(inputs)
	return "handOverParcel";
};

export { handoverparcel as "handOverParcel" };